module.exports = __webpack_public_path__ + "static/02-1cdb5ea3332c582c44a8f5b7e67b64c8.png";